import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/base/JsonLd';

const SITE_URL = import.meta.env.VITE_SITE_URL;

const aboutPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  'name': 'Sobre Nós - CSSBuySpreadsheet.asia',
  'description': 'Conheça a equipe por trás do CSSBuySpreadsheet.asia, o melhor CSSBuy Spreadsheet 2026 para compradores brasileiros e portugueses.',
  'url': `${SITE_URL}/sobre-nos`,
  'inLanguage': 'pt',
  'isPartOf': {
    '@type': 'WebSite',
    'name': 'CSSBuy Spreadsheet',
    'url': SITE_URL,
  },
};

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  'itemListElement': [
    {
      '@type': 'ListItem',
      'position': 1,
      'name': 'CSSBuy Spreadsheet',
      'item': SITE_URL,
    },
    {
      '@type': 'ListItem',
      'position': 2,
      'name': 'Sobre Nós',
      'item': `${SITE_URL}/sobre-nos`,
    },
  ],
};

export default function SobreNos() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <JsonLd data={aboutPageSchema} />
      <JsonLd data={breadcrumbSchema} />
      <Navbar />
      <main>
        <article className="w-full pt-24 pb-14 md:pt-28 md:pb-20">
          <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
            <div className="mb-8">
              <Link
                to="/"
                className="inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors duration-200"
              >
                <i className="ri-arrow-left-line text-base"></i>
                Voltar ao Início
              </Link>
            </div>

            <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-8">
              Sobre Nós
            </h1>

            <div className="space-y-5 text-foreground-700 leading-relaxed text-sm md:text-base">
              <p>
                O <strong>CSSBuySpreadsheet.asia</strong> nasceu da necessidade de oferecer à comunidade 
                lusófona um ponto de referência confiável para encontrar os melhores produtos através do 
                <strong>CSSBuy Spreadsheet</strong>. Somos um time de compradores experientes que entendem 
                as dificuldades e os desafios das compras internacionais.
              </p>
              <p>
                Nossa missão é simples: disponibilizar o <strong>melhor CSSBuy Spreadsheet</strong> de 
                forma gratuita, com links verificados, fotos QC reais e informações atualizadas diariamente. 
                Acreditamos que todo comprador merece acesso a produtos de qualidade com segurança e economia.
              </p>
              <p>
                O <strong>CSSBuy Spreadsheet 2026</strong> que oferecemos é constantemente aprimorado com 
                a contribuição da comunidade. Cada produto, cada avaliação e cada dica compartilhada ajuda 
                a tornar a experiência de compra mais segura e satisfatória para todos.
              </p>
              <p>
                Atendemos compradores do <strong>Brasil</strong> e <strong>Portugal</strong>, com conteúdo 
                adaptado às necessidades específicas de cada mercado. Nosso objetivo é ser o principal 
                recurso em língua portuguesa para quem busca produtos de qualidade através do 
                <strong>CSSBuy Spreadsheet</strong>.
              </p>
              <p>
                Para qualquer dúvida, sugestão ou colaboração, visite nossa página de 
                <Link to="/contato" className="text-primary-600 hover:text-primary-700 underline"> contato</Link>.
              </p>
            </div>
          </div>
        </article>
      </main>
      <Footer />
    </>
  );
}